import MainTabs from "../components/CallHistory/MainTabs";

const InvitePage = () => {
  return <MainTabs />;
};

export default InvitePage;
